import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { Link, useParams } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../Config/swal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

export default function ViewPayment() {
  const { PaymentId } = useParams();

  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(false);
console.log(paymentData,"paymentdata")
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_BASE_CRM_URL}payments/GetPayment/${PaymentId}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.Status) {
          setLoading(false);
          setPaymentData(data.ResultData[0]);
        } else {
          console.error("Fetched data is not an array:", data);
          setPaymentData([]);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <Base>
      <div className="page-heade mb-3">
        <div className="row align-items-center">
          <div className="col-7">
            <div className="page-title">
              <h4>View Payments</h4>
            </div>
          </div>

          <div className="col-5 d-flex justify-content-end">
            <Link to="/payments">
              <button className="btn btn-secondary btn-sm">
                <i className="fa-solid fa-list"></i>
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="card table-list-card">
        <div className="card-body">
          {loading ? (
            <div className="text-center my-5">
              <div className="containers m-auto">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </div>
          ) : (
            <form>
              <div className="row justify-content-between m-2">
                {/* Left Section */}
                <div className="col-12">
                  <h5 className="mb-1 fw-bold" style={{ color: "#1B2850" }}>
                    <i className="fa-solid fa-circle-info text-info"></i>{" "}
                    Payment Details
                  </h5>
                  <hr />

                  <div className="row g-4">
                    <div className="col-4">
                      <div className="d-flex align-items-start">
                        <i
                          className="fa-solid fa-file-invoice me-3 mt-1"
                          style={{ color: "#1B2850", fontSize: "18px" }}
                        ></i>

                        <div>
                         

                          <h6
                            className="mb-0 fw-bold text-dark"
                            // style={{ color: "#1B2850" }}
                          >
                            {paymentData?.InvoicePrefix}
                            {paymentData?.InvoiceNumber}
                          </h6>
                        </div>
                      </div>
                    </div>
                    {/* Amount */}
                    <div className="col-4">
                      <div className="d-flex align-items-start">
                        <i
                          className="fa-solid fa-indian-rupee-sign me-3 mt-1"
                          style={{ color: "#198754", fontSize: "18px" }}
                        ></i>

                        <div>
                          <h5 className="mb-0 text-success fw-bold">
                            {Number(paymentData?.amount || 0).toLocaleString(
                              "en-IN"
                            )}
                          </h5>
                        </div>
                      </div>
                    </div>

                    {/* Payment Mode */}

                    <div className="col-4">
                      <div className="d-flex align-items-start">
                        <i
                          className="fa-solid fa-fingerprint me-3 mt-1 text-warning"
                          style={{ color: "#1B2850" }}
                        ></i>

                        <div>
                          <span>{paymentData?.transactionid || "N/A"}</span>
                        </div>
                      </div>
                    </div>

                    {/* Payment Date */}
                    <div className="col-4">
                      <div className="d-flex align-items-start">
                        <i
                          className="fa-solid fa-calendar-days me-3 mt-1 text-info"
                          style={{ color: "#1B2850" }}
                        ></i>

                        <div>
                          <span>{formatDate(paymentData?.paymentdate)}</span>
                        </div>
                      </div>
                    </div>

                    {/* Transaction ID */}
                    <div className="col-3">
                      <div className="d-flex align-items-start">
                        <i
                          className="fa-solid fa-credit-card me-2 mt-1 text-primary"
                          style={{ color: "#1B2850" }}
                        ></i>

                        <div>
                          <span>{paymentData?.paymentsModeName || "N/A"}</span>
                        </div>
                      </div>
                    </div>

                    {/* Remarks */}
                    <div className="col-9">
                      <div className="d-flex align-items-start">
                        <i
                          className="fa-solid fa-note-sticky me-2 mt-1 text-danger"
                          style={{ color: "#1B2850" }}
                        ></i>

                        <div>
                          <span>
                            {paymentData?.note || "No remarks available."}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </Base>
  );
}
